import React, {useState} from 'react'
import * as VisuallyHidden from '@radix-ui/react-visually-hidden'
import {saveLearningCenterConsent} from '../../../overrides/app/utils/helpers'
import {Dialog, DialogContent, DialogTitle, DialogDescription} from '@/components/ui/dialog'
import useLearningCenter from '~/app/hooks/use-learning-center'
import {useCustomerType} from '@salesforce/commerce-sdk-react'
import useTpaMarketingConsent from '~/app/hooks/use-tpa-marketing-consent'

export interface TpaLearningCenterConsentProps {
    modalContent?: string
    className?: string
    [key: string]: any
}

/**
 * View component for TPA Learning Center Consent
 * Renders the code field as HTML (for embed/script/etc)
 */

function TpaLearningCenterConsent({
    modalContent,
    className,
    ...props
}: TpaLearningCenterConsentProps) {
    const [open, setOpen] = useState(true)
    const {updateConsentData} = useLearningCenter()
    const {isRegistered} = useCustomerType()
    const {setExplicitConsent} = useTpaMarketingConsent()

    const closeDialog = async (consent) => {
        saveLearningCenterConsent(consent)

        if (consent && isRegistered) {
            await setExplicitConsent()
        }

        if (isRegistered) {
            try {
                await updateConsentData(consent)
            } catch {
                // Silently handle consent update errors
            }
        }

        setOpen(false)
    }

    return (
        <Dialog open={open} data-testid="tpaLearningCenterConsent-Dialog">
            <DialogContent
                className="
                max-w-[48rem] gap-0
                px-[3.25rem] py-10
                max-h-[calc(100vh-2rem)]
                overflow-y-auto
                max-[400px]:px-[3.25rem] max-[400px]:py-10
                max-[700px]:px-4 max-[700px]:py-6
                max-[700px]:w-[calc(100vw-1.5rem)]
              "
                hideCloseBtn={true}
                data-testid="tpaLearningCenterConsent-DialogContent"
            >
                <VisuallyHidden.Root>
                    <DialogTitle data-testid="tpaLearningCenterConsent-DialogTitle">
                        TPA Learning Center Consent
                    </DialogTitle>
                    <DialogDescription data-testid="tpaLearningCenterConsent-DialogDescription">
                        TPA Welcome learning center consent popup modal
                    </DialogDescription>
                </VisuallyHidden.Root>
                <div className={className} {...props}>
                    {modalContent ? (
                        <div dangerouslySetInnerHTML={{__html: modalContent}} />
                    ) : (
                        <div style={{color: '#888'}}>[No content provided]</div>
                    )}
                </div>
                <div className="w-full text-right">
                    <button
                        className="w-1/2 sm:w-36 pt-3.5 pb-3.5 px-8 sm:mr-4 text-[#727272] font-bold text-sm leading-normal bg-[#DADADA] border-[#ff295b] rounded-[2.1875rem]"
                        onClick={() => closeDialog(false)}
                    >
                        No Thanks
                    </button>
                    <button
                        className="w-1/2 sm:w-64 pt-3.5 pb-3.5 px-9 text-white font-bold font-grotesque text-sm leading-normal bg-[#49388E] border-[#ff295b] rounded-[2.1875rem]"
                        onClick={() => closeDialog(true)}
                    >
                        Yes, I&apos;m IN
                    </button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default TpaLearningCenterConsent
